import { MessageTypes } from './message-types';
import { TranslationItem } from './translation-item';

export interface ConversationMessage {
    id: string;
    conversationId: string;
    messageId: string;
    content?: string;
    createdAt: Date;
    sender: string;
    isSent: boolean;
    messageType: MessageTypes;
    translation?: TranslationItem;
    note?: ConversationTreatmentNote;
}

export interface ConversationTreatmentNote {
    id: number;
    editors: string[];
    messageId: string;
    treatmentId: string;
}
